import { render, staticRenderFns } from "./KTStage.vue?vue&type=template&id=4516907b&"
import script from "./KTStage.vue?vue&type=script&lang=js&"
export * from "./KTStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports